import { api } from "./authService";

export interface UniversityItem {
  id: string;
  name: string;
  short_name?: string;
  code: string;
  institution_type?: string;
  institution_type_name?: string;
  institution_type_code?: string;
  country: string;
  state?: string;
  website?: string;
  approval_body?: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export const universityService = {
  getUniversities: async (params?: {
    search?: string;
    is_active?: boolean;
    institution_type?: string;
    institution_type_code?: string;
    institution_type_name?: string;
    state?: string;
    country?: string;
  }): Promise<{ results: UniversityItem[] } | UniversityItem[]> => {
    const response = await api.get("/master/universities/", { params });
    return response.data;
  },

  createUniversity: async (data: {
    name: string;
    short_name?: string;
    code: string;
    institution_type?: string;
    country?: string;
    state?: string;
    website?: string;
    approval_body?: string;
    is_active?: boolean;
  }): Promise<UniversityItem> => {
    const response = await api.post("/master/universities/", data);
    return response.data;
  },

  updateUniversity: async (
    id: string,
    data: Partial<{
      name: string;
      short_name: string;
      code: string;
      institution_type: string;
      country: string;
      state: string;
      website: string;
      approval_body: string;
      is_active: boolean;
    }>
  ): Promise<UniversityItem> => {
    const response = await api.patch(`/master/universities/${id}/`, data);
    return response.data;
  },

  deleteUniversity: async (id: string): Promise<void> => {
    await api.delete(`/master/universities/${id}/`);
  },
};
